(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  function initGalleryDynamicHeight(gallery) {
    if (!gallery || gallery.dataset.dynamicHeightReady === 'true') return;

    gallery.dataset.dynamicHeightReady = 'true';

    const slider = gallery.querySelector('.product__media-list.slider--mobile');
    if (!slider) return;

    const slides = Array.from(slider.querySelectorAll('.product__media-item'));
    if (!slides.length) return;

    let rafId = null;

    function getCurrentSlide() {
      const sliderRect = slider.getBoundingClientRect();
      const sliderCenter = sliderRect.left + sliderRect.width / 2;

      return slides.reduce(
        (closest, slide) => {
          const slideRect = slide.getBoundingClientRect();
          const slideCenter = slideRect.left + slideRect.width / 2;
          const distance = Math.abs(slideCenter - sliderCenter);

          return distance < closest.distance ? { slide, distance } : closest;
        },
        { slide: slides[0], distance: Infinity }
      ).slide;
    }

    function updateHeight() {
      if (!mobileQuery.matches) {
        slider.style.height = '';
        return;
      }

      const currentSlide = getCurrentSlide();
      if (!currentSlide) return;

      const currentHeight = Math.ceil(currentSlide.getBoundingClientRect().height);

      if (currentHeight > 0) {
        slider.style.height = `${currentHeight}px`;
      }
    }

    function requestUpdate() {
      if (rafId) {
        cancelAnimationFrame(rafId);
      }

      rafId = requestAnimationFrame(updateHeight);
    }

    slider.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', requestUpdate);
    } else {
      mobileQuery.addListener(requestUpdate);
    }

    const mutationObserver = new MutationObserver(requestUpdate);
    mutationObserver.observe(slider, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style'],
    });

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(requestUpdate);
      slides.forEach((slide) => resizeObserver.observe(slide));
    }

    slider.querySelectorAll('img, video, iframe').forEach((media) => {
      media.addEventListener('load', requestUpdate, { passive: true });
      media.addEventListener('loadedmetadata', requestUpdate, { passive: true });
      media.addEventListener('loadeddata', requestUpdate, { passive: true });
    });

    setTimeout(updateHeight, 0);
    setTimeout(updateHeight, 300);
    setTimeout(updateHeight, 800);
  }

  function initAllGalleries() {
    document.querySelectorAll('media-gallery').forEach(initGalleryDynamicHeight);
  }

  document.addEventListener('DOMContentLoaded', initAllGalleries);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('media-gallery').forEach(initGalleryDynamicHeight);
  });

  window.addEventListener('load', initAllGalleries);
})();